exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedorTiempoPaciente .contenedorStepper .cabezaStepper .tamanoPosicion .v-application .primary{color:red}.contenedorTiempoPaciente .contenedorStepper .cabezaStepper .tamanoPosicion div{display:flex!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f11a69f4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Gestion/TiemposPaciente/tiemposPaciente.vue
// module id = 1072
// module chunks = 0